<template>
<div>
  消息1

  <router-link to="/c1/c11/detail?id=666" >111</router-link>
  <router-link :to="getUrl(777)">222</router-link>
  <br/>

  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: "c11",
  methods:{
    getUrl(v){
      return "/c1/c11/detail?id="+v
    }

  }
}
</script>

<style scoped>

</style>